// extracted by mini-css-extract-plugin
export default {"collaborators_avatar":"Collaborators_collaborators_avatar__c2EZl","collaborators_menuAvatar":"Collaborators_collaborators_menuAvatar__ZSOCe"};